import React from 'react'

const Chip = ({status}) => {
    return (
        <div class="chip ml-3">
            <div class="chip-content">{status}</div>
        </div>
    )
}

export default Chip